// The thread list — maps `CommentThread[]` → `<CommentCard>` rows, or an
// honest empty state for the current filter. Pure presentation: the
// open/resolved filtering already happened server-side (W1); this component
// only projects.

import { useTranslation } from 'react-i18next'
import type { CommentThread } from '@/domain/comments/entity'
import { CommentCard } from './CommentCard'

interface CommentThreadListProps {
  threads: CommentThread[]
  onReply: (threadId: string, body: string) => void
  onToggleResolve: (threadId: string, isResolved: boolean) => void
}

export function CommentThreadList({
  threads,
  onReply,
  onToggleResolve,
}: CommentThreadListProps): JSX.Element {
  const { t, i18n } = useTranslation()

  if (threads.length === 0) {
    return (
      <div
        data-testid="comments-list-empty"
        className="px-3.5 py-6 text-center text-xs leading-relaxed text-ink/60"
      >
        {t('comments.empty')}
      </div>
    )
  }

  return (
    <ul data-testid="comments-thread-list" className="flex flex-col">
      {threads.map((thread) => (
        <CommentCard
          key={thread.id}
          thread={thread}
          language={i18n.language}
          onReply={onReply}
          onToggleResolve={onToggleResolve}
        />
      ))}
    </ul>
  )
}
